// TODO: refactor this method in ApiBase class
import axios from 'axios'
const api = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const contractsService = {
  /**
   * @param {Object} params
   * @param {Integer} params.page
   * @param {Integer} params.perPage
   * @param {String} params.q
   * @param {Integer} params.companyId
   * @param {String} params.byStatus
   * @param {String} params.byAccredited
   * @param {String} params.byOffice
   * @returns {Promise}
   *
   */

  index: ({
    page,
    q,
    perPage,
    companyId,
    byStatus,
    byAccredited,
    byOffice
  }) => {
    const params = {}

    if (page) {
      params.page = page
    }

    if (perPage) params.per_page = perPage

    if (q) {
      params.q = q
    }

    if (byAccredited) {
      params.by_accredited = byAccredited
    }

    if (byStatus) {
      params.by_status = byStatus
    }

    if (byOffice) params.by_office_id = byOffice

    const queryParams = new URLSearchParams(params)
    if (companyId === null) {
      return api.get('/api/v1/contractor/contracts?' + queryParams)
    }
    return api.get(
      `/api/v1/contractor/companies/${companyId}/contracts?` + queryParams
    )
  },
  create: (body) => api.post('/api/v1/contractor/contracts', body),
  update: ({ body, id }) => api.put(`/api/v1/contractor/contracts/${id}`, body),
  calculate: (body) => api.post('/api/v1/contractor/contracts/calculate', body)
}
